module.exports = __webpack_public_path__ + "img/11.16e763b3.png";